import { Link } from 'react-router-dom'

export default function About() {
  return (
    <main className="min-h-screen px-6 md:px-12 py-12 max-w-2xl mx-auto">
      <Link to="/" className="font-mono text-sm text-[var(--color-muted)]">← back</Link>
      <h1 className="text-4xl font-medium mt-8 mb-6">how this works</h1>
      <div className="space-y-6 text-[var(--color-muted)] leading-relaxed">
        <p>
          One photo in. A 3D Gaussian Splat out. Rotate, zoom, share — all in your browser, no install.
        </p>
        <p>
          The reconstruction model is{' '}
          <a className="text-[var(--color-accent)] underline" href="https://replicate.com/ndreca/hunyuan3d-2" target="_blank" rel="noopener noreferrer">
            Tencent Hunyuan3D-2 (Turbo)
          </a>
          {' '}running on Replicate. Diffusion-based: it hallucinates novel views around your photo, then extracts a watertight textured mesh at 512³ octree resolution.
        </p>
        <p>
          The viewer is Google's{' '}
          <code className="font-mono text-xs bg-white/10 px-1.5 py-0.5 rounded">&lt;model-viewer&gt;</code>
          {' '}web component. Rendering happens 100% on your GPU.
        </p>
        <p>
          Backend: Cloudflare Workers + R2 storage. Open source on{' '}
          <a className="text-[var(--color-accent)] underline" href="https://github.com/Theovia/eigen-splat" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>.
        </p>
        <p className="text-xs pt-6 border-t border-white/10">
          Photos and scans auto-delete after 24h. We don't train on your data. Don't upload faces of others without consent.
        </p>
      </div>
    </main>
  )
}
